import React, { Component } from "react";
import DrawerToogleButton from "../SideDrawer/DrawerToggleButton";
import "./Toolbar.css";

export default class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", () => {
      const isTop = window.scrollY < 0.1;
      if (isTop !== true) {
        this.setState({ scrolled: true });
      } else {
        this.setState({ scrolled: false });
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll");
  }

  render() {
    return (
      <div>
        <header
          className={
            this.state.scrolled ? "toolbar toolbar-scrolled" : "toolbar"
          }
        >
          <nav className="toolbar__navigation">
            <div className="toolbar__logo">
              <a href="https://codeops.tech">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.white1.png`}
                  width="60%"
                  alt="codeOps logo"
                />
              </a>
            </div>
            <div className="spacer"></div>
            <div className="toolbar__navigation-items">
              <ul>
                <li className="nav-item">
                  <a href="https://codeops.tech/#jetbrainstools">
                    JetBrains Tools
                  </a>
                </li>
                <li className="nav-item">
                  <a href="https://codeops.tech/#consulting">Consulting</a>
                </li>
                <li className="nav-item">
                  <a href="https://codeops.tech/#products">Products</a>
                </li>
                <li className="nav-item">
                  <a href="https://codeops.tech/#trainings">Trainings</a>
                </li>
              </ul>
            </div>
            <div className="toolbar__toggle-button">
              <DrawerToogleButton click={this.props.drawerClickHandle} />
            </div>
          </nav>
        </header>
      </div>
    );
  }
}
